module.exports = __webpack_public_path__ + "me.svg?9b0de763e06e97c4fc909bcc063d4271";